import * as api from './api'

export default {
  async loadCashSummary () {
    const { data } = await api.loadCashSummary() || {}

    if (data?.code === 200) {
      return { data: data.data }
    }

    return { error: data?.code }
  },
  async loadSalesSummary () {
    const { data } = await api.loadSalesSummary() || {}

    if (data?.code === 200) {
      return { data: data.data }
    }

    return { error: data?.code }
  }
}